import cloneDeepWith from 'lodash/cloneDeepWith';
import isPlainObject from 'lodash/isPlainObject';
import { createUuid } from '../../PredefinedConfig/Uuid';
export function initPredefinedConfigWithUuids(predefinedConfig) {
    const customizer = (value) => {
        // so whenever we clone a plain object,
        // we add a Uuid property
        // jw added 9/8/20: unless there is on there already
        if (isPlainObject(value) && value != predefinedConfig) {
            if (value.Uuid == null || value.Uuid == undefined) {
                value.Uuid = createUuid();
            }
        }
    };
    return cloneDeepWith(predefinedConfig, customizer);
}
export function checkValidPrimaryKey(adaptable) {
    const pkColumn = adaptable.api.columnApi.getColumnWithColumnId(adaptable.adaptableOptions.primaryKey);
    if (pkColumn == undefined && !adaptable.adaptableOptions.autogeneratePrimaryKey) {
        const errorMessage = `The Primary Key Column '${adaptable.adaptableOptions.primaryKey}' does not exist.  This will affect many functions in Adaptable.`;
        if (adaptable.adaptableOptions.alertOptions.showMissingPrimaryKeyAlert == true) {
            // show an alert if that is the option
            adaptable.api.alertApi.showAlertError('No Primary Key', errorMessage);
        }
        else {
            if (adaptable.adaptableOptions.columnOptions.showMissingColumnsWarning == true) {
                adaptable.logger.consoleError(errorMessage);
            }
        }
        return false;
    }
    return true;
}
export function AdaptableObjectExistsInState(array, itemToCheck) {
    if (array == null) {
        return false;
    }
    return array.findIndex((abObject) => abObject.Uuid == itemToCheck.Uuid) > -1;
}
export function getAppropriateAccessLevel(adaptableObject, moduleAccessLevel) {
    // we always return the Module Access Level unless the following condition is met:
    // the object prpoerty has been set and set to true and the Module entitlement is full
    if (moduleAccessLevel == 'Full' &&
        adaptableObject &&
        adaptableObject.IsReadOnly &&
        adaptableObject.IsReadOnly == true) {
        return 'ReadOnly';
    }
    return moduleAccessLevel;
}
export function runAdaptableComparerFunction(columnId, columnValues, adaptable) {
    return function compareItemsOfCustomSort(valueA, valueB, nodeA, nodeB) {
        let firstElementValueString = nodeA
            ? adaptable.getDisplayValueFromRowNode(nodeA, columnId)
            : valueA;
        let secondElementValueString = nodeB
            ? adaptable.getDisplayValueFromRowNode(nodeB, columnId)
            : valueB;
        let indexFirstElement = columnValues.indexOf(firstElementValueString);
        let containsFirstElement = indexFirstElement >= 0;
        let indexSecondElement = columnValues.indexOf(secondElementValueString);
        let containsSecondElement = indexSecondElement >= 0;
        //if none of the element are in the list we jsut return normal compare
        if (!containsFirstElement && !containsSecondElement) {
            if (valueA == valueB) {
                return 0;
            }
            return valueA < valueB ? -1 : 1;
        }
        //if first item not in the list make sure we put it after the second item
        if (!containsFirstElement) {
            return 1;
        }
        //if second item not in the list make sure we put it after the first item
        if (!containsSecondElement) {
            return -1;
        }
        //return the comparison from the list if the two items are in the list
        return indexFirstElement - indexSecondElement;
    };
}
export function addUuidAndSource(adaptableObject) {
    if (!adaptableObject.Uuid) {
        adaptableObject.Uuid = createUuid();
    }
    adaptableObject.Source = 'User';
    return adaptableObject;
}
export function removeUuidAndSource(adaptableObject) {
    const clonedObject = structuredClone(adaptableObject);
    const sanitiseObject = (object) => {
        for (const key in object) {
            if (key === 'Source' || key === 'Uuid') {
                delete object[key];
            }
            else if (Array.isArray(object[key])) {
                object[key].forEach((item) => sanitiseObject(item));
            }
            else if (typeof object[key] === 'object') {
                sanitiseObject(object[key]);
            }
        }
    };
    sanitiseObject(clonedObject);
    return clonedObject;
}
export const AdaptableHelper = {
    initPredefinedConfigWithUuids,
    checkValidPrimaryKey,
    AdaptableObjectExistsInState,
    runAdaptableComparerFunction,
    getAppropriateAccessLevel,
    addUuidAndSource,
    removeUuidAndSource,
};
export default AdaptableHelper;
